import { Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function KeepZeroUTitle() {
    const { isRegimeDraftLocked } = useBoundContext()
    if (isRegimeDraftLocked) return ""
    return (
        <Stack spacing={2} sx={{ p: 1 }}>
            <Typography component="span">
                Check this box to suppress the 0U warning, if you believe that the task does not need a frequency and
                timing. Otherwise you can update the frequency to fit your needs.
            </Typography>
            <Typography color="text.secondary" component="span">
                0U (Zero U) which means the frequency is to be defined by the user based on a site-specific assessment.
            </Typography>
        </Stack>
    )
}
